export const checkboxData = [
  {
    title: 'Account 1',
    content: 'reference no. -----0060',
    description: 'This is your Everyday Access account.',
  },
  {
    title: 'Account 2',
    content: 'reference no. -----99999',
    description: 'This is your Everyday Access account.',
  },
]

export const dataWithModal = [
  {
    title: 'Transaction Account',
    content: '•••• 0060',
    description: 'This is your Everyday Access account.',
    havaInfoModal: true,
  },
  {
    title: 'Savings Account',
    content: '•••• 0055',
    description: (
      <>
        <p style={{ color: '#6f777b' }}>Held with 1 acount holder</p>
        <p>This is your Goal Saver account</p>
        <br></br>
        <p>
          <b>Single consent enabled</b>
        </p>
        <p>Account holders can share this joint account data at any time.</p>
        <p>
          You can change sharing preferences for this account by going to
          ‘Settings {'>'} Data sharing {'>'} Account permissions’.
        </p>
      </>
    ),
    havaInfoModal: true,
  },
]

export const dataWithAccordion = [
  {
    title: 'Name, occupation, contact details',
    content:
      'We’ll use this data to prepopulate application forms and products.',
    accordionHint: 'What does this include?',
    accordionContent: (
      <div>
        This includes:
        <ul>
          <li>Names</li>
          <li>Occupation</li>
          <li>Phone</li>
          <li>Email address</li>
          <li>Mail address</li>
          <li>Residential address</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'Account balance and details',
    content: 'We’ll use this data to propose similar products and bundles.',
    accordionHint: 'What does this include?',
    accordionContent: (
      <div>
        This includes:
        <ul>
          <li>Name of account</li>
          <li>Type of account</li>
          <li>Account balance</li>
          <li>Account number</li>
          <li>Interest rates</li>
          <li>Fees</li>
          <li>Discounts</li>
          <li>Account terms</li>
          <li>Account mail address</li>
        </ul>
      </div>
    ),
  },
  {
    title: 'Transaction details',
    content:
      'We’ll use this data to propose products that suit your spending lifestyle.',
    accordionHint: 'What does this include?',
    accordionContent: (
      <div>
        This includes :
        <ul>
          <li>Incoming and outgoing transactions</li>
          <li>Amounts</li>
          <li>Dates</li>
          <li>Descriptions of transactions</li>
          <li>
            Who you have sent money to and received money from; (e.g. their
            name)
          </li>
        </ul>
      </div>
    ),
  },
]
